class StickyNav extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    this.target =
      document.querySelector('product-recommendations') ||
      document.querySelector('footer');

    if (!this.target) {
      console.warn('StickyNav: target section not found');
      return;
    }

    this.setupObserver();
  }

  setupObserver() {
    this.observer1 = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          this.hide();
        } else {
          this.show();
        }
      },
      {
        root: null,
        threshold: 0,
        rootMargin: '-80px 0px 0px 0px',
      }
    );

    this.observer1.observe(this.target);

    this.observer2 = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          this.hide();
        } else {
          this.show();
        }
      },
      {
        root: null,
        threshold: 0,
        rootMargin: '0px 0px 0px 0px',
      }
    );

    this.observer2.observe(document.querySelector(".product-details button.add-to-cart-button"));
  }

  hide() {
    this.classList.add('is-hidden');
  }

  show() {
    this.classList.remove('is-hidden');
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}

customElements.define('sticky-nav', StickyNav);